import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../../styles';
import { ColumnToggleProps } from './column-toggle';
import { ColumnProps } from './../column';
import ColumnCheckbox from './column-checkbox';
import ColumnToggleList from './column-list';
import { IconButton } from '../../../atoms/buttons';
import { FractionString } from '../../../atoms/fraction-string';

export interface Props extends ColumnToggleProps {
  section: string;
  sectionColumns: ColumnProps[];
  checked: boolean;
}

interface State {
  open: boolean;
}

class ColumnToggleSection extends React.Component<Props, State> {
  state = {
    open: false,
  };

  onToggle = () => this.setState(({ open }) => ({ open: !open }));

  onCheck = () => {
    const {
      checked: sectionChecked,
      visibleColumns,
      sectionColumns,
      toggleColumns,
    } = this.props;

    const columnKeysToToggle = sectionColumns.reduce((result, { dataKey }) => {
      const columnChecked = visibleColumns[dataKey];
      return sectionChecked || !columnChecked ? [...result, dataKey] : result;
    }, []);
    toggleColumns(columnKeysToToggle);
  };

  render() {
    const {
      className,
      section,
      checked,
      sectionColumns,
      visibleColumns,
    } = this.props;
    const { open } = this.state;

    const icon = open ? 'caretUp' : 'caretDown';
    const visibleCount = sectionColumns.filter(
      ({ dataKey }) => visibleColumns[dataKey],
    ).length;

    return (
      <div className={className}>
        <div className={`toggle-section ${open ? 'opened' : ''}`}>
          <div className="section-title">
            <ColumnCheckbox
              label={section}
              checked={checked}
              onCheck={this.onCheck}
            />
            <FractionString
              count={visibleCount}
              total={sectionColumns.length}
            />
          </div>
          <IconButton
            icon={icon}
            baseColor={colors.black700}
            size="xs"
            onClick={this.onToggle}
          />
        </div>
        <div className="toggle-content">
          {open && (
            <ColumnToggleList
              {...this.props}
              className="toggle-columns"
              columns={sectionColumns}
            />
          )}
        </div>
      </div>
    );
  }
}

export default styled(ColumnToggleSection)`
  border-top: 1px solid ${colors.grey150};

  .toggle-section {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.opened {
      background: ${colors.green50};
    }

    .section-title {
      display: flex;
      align-items: center;
      margin-right: 0.5rem;
    }

    button {
      padding: 0 1rem;
    }
  }

  .toggle-columns {
    padding-left: 1rem;
  }
`;
